import styles from './DocumentsToProject.module.scss';
import {Pagination} from "../../../../../../components";
import React, {useCallback, useState} from "react";
import {DataCollection} from "../../../../../../utils";
import {createAgreementProvider} from "../../../../../../di";
import {useErrorCallback} from "../../../../../../hooks";
import {DocumentsToProjectItem, PageOutOfRangeGuard} from "../DocumentsElements";
import {ProjectDocumentsAgreement} from "../../../../../../api-client/models/documents/ProjectDocumentsAgreement";
import FilterIcon from "../../../../../../components/filters/FilterIcon";
import {FilterDocuments} from "../FilterDocuments";
import {Filter} from "../FilterDocuments/FilterDocuments";

const safeDecode = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

const normalizeQueryFilter = (value: Partial<Filter>): Partial<Filter> => {
  const normalized: Partial<Filter> = {...value};
  if (typeof value.dateFrom === "string" && value.dateFrom !== "") {
    normalized.dateFrom = safeDecode(value.dateFrom);
  }
  if (typeof value.dateTo === "string" && value.dateTo !== "") {
    normalized.dateTo = safeDecode(value.dateTo);
  }
  if (value.isCommercialOffer !== undefined && value.isCommercialOffer !== null) {
    normalized.isCommercialOffer = String(value.isCommercialOffer) === "true";
  }
  return normalized;
};

export const defaultFilter: Filter = {
  search: "",
  dateFrom: "",
  dateTo: "",
  type: [],
  isCommercialOffer: null
};

const DocumentsToProject = () => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [filter, setFilter] = useState<Filter>(defaultFilter);

  const [agentDocuments, setAgentDocuments] =
        useState<DataCollection<ProjectDocumentsAgreement>>(new DataCollection());
  const handleError = useErrorCallback();

  const loadData = useCallback(async (page: number, perPage: number) => {
    setLoading(true);
    try {
      const provider = await createAgreementProvider();
      const results = await provider.getProjectAgreements(page, perPage, filter);
      const newCollection = new DataCollection<ProjectDocumentsAgreement>();
      newCollection.setCollection(results);
      setAgentDocuments(newCollection);
    } catch (error: any) {
      await handleError(error);
    } finally {
      setLoading(false);
    }
  }, [filter]);

  const updateFilter = (filter: Filter): void => {
    setFilter({...filter});
  };

  const toggleFilterPanel = (): void => {
    setActive((prevState) => !prevState);
  };

  return (<div className={styles.documents}>
    <Pagination
      onLoad={loadData}
      count={agentDocuments.count}
      totalCount={agentDocuments.totalCount}
      filterObject={filter}
      initialChangeFilter={(value: Partial<Filter>) => setFilter({...filter, ...normalizeQueryFilter(value)})}
    >
      <PageOutOfRangeGuard loading={loading}/>
      <div className={styles.documents__filtersContainer}>
        <FilterIcon active={active} onClick={toggleFilterPanel}/>
      </div>
      {active && <FilterDocuments filter={filter}
        onChange={updateFilter} isDocumentToProject={true}/>}
      <ul className={styles.documents__title}>
        <Pagination.Content loading={loading}>
          <DocumentsToProjectItem documentsList={agentDocuments}/>
        </Pagination.Content>
      </ul>
      <Pagination.Paginator/>
    </Pagination>
  </div>
  );
};

export default DocumentsToProject;
